module.exports = __webpack_public_path__ + "static/media/HeartOnYourTeeNew.ab63bfc0.jpg";